// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fe601659","453":"46c606a0","667":"57d0bdde","946":"11661fa1"}[chunkId] + ".chunk.js";
};